import { render, staticRenderFns } from "./RankingComments.vue?vue&type=template&id=1452dea9&scoped=true&lang=pug&"
import script from "./RankingComments.vue?vue&type=script&lang=ts&"
export * from "./RankingComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452dea9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1452dea9')) {
      api.createRecord('1452dea9', component.options)
    } else {
      api.reload('1452dea9', component.options)
    }
    module.hot.accept("./RankingComments.vue?vue&type=template&id=1452dea9&scoped=true&lang=pug&", function () {
      api.rerender('1452dea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/RankingComments.vue"
export default component.exports